module.exports = __webpack_public_path__ + "static/media/dc.d1c1c223.jpg";